import TabToggle from 'components/commons/tab-toogle'
import { Checkbox, InlineError, Input } from 'avo-ui'
import MultipleSelect from 'components/commons/multiple-select'
import Select from 'components/commons/select'
import CheckboxList from 'components/commons/checkbox-list'

export const Restriction = ({
    sectionRef,
    voucherDetail,
    onFilterOptions,
    onChangeRestriction,
    options,
    onSearchOptions,
    errorForm,
}) => {
    return (
        <div ref={sectionRef}>
            <TabToggle
                title={'Restriction'}
                content={
                    <div className={'flex space-x-16'}>
                        <div className={'flex-1 flex-col space-y-5'}>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Minimum Spend</div>
                                <Input
                                    type={'currency'}
                                    className={'flex-1'}
                                    name={'minimum_amount'}
                                    addonBefore={'Rp'}
                                    placeholder={'Masukkan nilai minimum'}
                                    value={voucherDetail?.minimum_amount}
                                    onChange={(item) => onChangeRestriction({ [item?.name]: item?.value })}
                                />
                                <InlineError className='mt-2' message={errorForm?.restriction?.minimum_amount} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'flex flex-col space-y-3'}>
                                    <Checkbox
                                        name={'individual_use'}
                                        checked={voucherDetail?.individual_use}
                                        label={'Individual Use Only'}
                                        onChange={(item) => onChangeRestriction({ [item?.name]: item?.checked })}
                                    />
                                    <InlineError className='mt-2' message={errorForm?.restriction?.individual_use} />
                                </div>
                                <div className={'flex flex-col space-y-3'}>
                                    <Checkbox
                                        name={'individual_type'}
                                        checked={voucherDetail?.individual_type}
                                        label={'Individual Use Only in This Voucher Type'}
                                        onChange={(item) => onChangeRestriction({ [item?.name]: item?.checked })}
                                    />
                                    <InlineError className='mt-2' message={errorForm?.restriction?.individual_type} />
                                </div>
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Includes Product</div>
                                <MultipleSelect
                                    name={'include_product_ids'}
                                    placeholder={'Search Product...'}
                                    onSearch={(keyword) => onSearchOptions('include_product', keyword)}
                                    value={voucherDetail?.include_product_ids}
                                    options={onFilterOptions(options?.include_product, 'exclude_product_ids')}
                                    onChange={(item) => onChangeRestriction({ [item?.name]: item?.value })}
                                />
                                <InlineError className='mt-2' message={errorForm?.restriction?.include_product_ids} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Includes Category</div>
                                <Select
                                    name={'include_category_ids'}
                                    className={'flex-1'}
                                    optionsClassName={'max-h-40'}
                                    placeholder={'Pilih kategori'}
                                    options={onFilterOptions(options?.include_category, 'exclude_category_ids')}
                                    value={voucherDetail?.include_category_ids || []}
                                    searchable
                                    isMultiple
                                    onChange={(item) => onChangeRestriction({ [item?.name]: item?.value })}
                                    onSearch={(keyword) => onSearchOptions('include_category', keyword)}
                                />
                                <InlineError className='mt-2' message={errorForm?.restriction?.include_category_ids} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Includes Brand</div>
                                <Select
                                    name={'include_brand_ids'}
                                    className={'flex-1'}
                                    optionsClassName={'max-h-40'}
                                    placeholder={'Pilih brand'}
                                    options={onFilterOptions(options?.include_brand, 'exclude_brand_ids')}
                                    value={voucherDetail?.include_brand_ids || []}
                                    searchable
                                    isMultiple
                                    onChange={(item) => onChangeRestriction({ [item?.name]: item?.value })}
                                    onSearch={(keyword) => onSearchOptions('include_brand', keyword)}
                                />
                                <InlineError className='mt-2' message={errorForm?.restriction?.include_brand_ids} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Shipping Courier</div>
                                <CheckboxList
                                    className={'flex-1'}
                                    classNameOptions={'!max-h-24'}
                                    name={'Courier'}
                                    options={options?.shipping_courier}
                                    values={voucherDetail?.shipping_courier || []}
                                    onChange={(value) => onChangeRestriction({ shipping_courier: value })}
                                />
                                <InlineError className='mt-2' message={errorForm?.restriction?.shipping_courier} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Allowed Email</div>
                                <MultipleSelect
                                    name={'allowed_email'}
                                    placeholder={'Search Email...'}
                                    onSearch={(keyword) => onSearchOptions('allowed_email', keyword)}
                                    value={voucherDetail?.allowed_email || []}
                                    options={options?.allowed_email}
                                    onChange={(item) => onChangeRestriction({ [item?.name]: item?.value })}
                                />
                                <InlineError className='mt-2' message={errorForm?.restriction?.allowed_email} />
                            </div>
                        </div>
                        <div className={'flex-1 flex-col space-y-5'}>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Maximum Spend</div>
                                <Input
                                    type={'currency'}
                                    className={'flex-1'}
                                    name={'maximum_amount'}
                                    addonBefore={'Rp'}
                                    placeholder={'Masukkan nilai maksimum'}
                                    value={voucherDetail?.maximum_amount}
                                    onChange={(item) => onChangeRestriction({ [item?.name]: item?.value })}
                                />
                                <InlineError className='mt-2' message={errorForm?.restriction?.maximum_amount} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <Checkbox
                                    name={'exclude_sale_items'}
                                    checked={voucherDetail?.exclude_sale_items}
                                    label={'Exclude Sale Item'}
                                    onChange={(item) => onChangeRestriction({ [item?.name]: item?.checked })}
                                />
                                <InlineError className='mt-2' message={errorForm?.restriction?.exclude_sale_items} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Excludes Product</div>
                                <MultipleSelect
                                    name={'exclude_product_ids'}
                                    placeholder={'Search Product...'}
                                    onSearch={(keyword) => onSearchOptions('exclude_product', keyword)}
                                    value={voucherDetail?.exclude_product_ids}
                                    options={onFilterOptions(options?.exclude_product, 'include_product_ids')}
                                    onChange={(item) => onChangeRestriction({ [item?.name]: item?.value })}
                                />
                                <InlineError className='mt-2' message={errorForm?.restriction?.exclude_product_ids} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Excludes Category</div>
                                <Select
                                    name={'exclude_category_ids'}
                                    className={'flex-1'}
                                    optionsClassName={'max-h-40'}
                                    placeholder={'Pilih kategori'}
                                    options={onFilterOptions(options?.exclude_category, 'include_category_ids')}
                                    value={voucherDetail?.exclude_category_ids || []}
                                    searchable
                                    isMultiple
                                    onChange={(item) => onChangeRestriction({ [item?.name]: item?.value })}
                                    onSearch={(keyword) => onSearchOptions('exclude_category', keyword)}
                                />
                                <InlineError className='mt-2' message={errorForm?.restriction?.exclude_category_ids} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Excludes Brand</div>
                                <Select
                                    name={'exclude_brand_ids'}
                                    className={'flex-1'}
                                    optionsClassName={'max-h-40'}
                                    placeholder={'Pilih brand'}
                                    options={onFilterOptions(options?.exclude_brand, 'include_brand_ids')}
                                    value={voucherDetail?.exclude_brand_ids || []}
                                    searchable
                                    isMultiple
                                    onChange={(item) => onChangeRestriction({ [item?.name]: item?.value })}
                                    onSearch={(keyword) => onSearchOptions('exclude_brand', keyword)}
                                />
                                <InlineError className='mt-2' message={errorForm?.restriction?.exclude_brand_ids} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <div className={'font-semibold text-blue-90'}>Payment Method</div>
                                <CheckboxList
                                    className={'flex-1'}
                                    classNameOptions={'!max-h-24'}
                                    name={'Payment Method'}
                                    options={options?.payment_method}
                                    values={voucherDetail?.payment_method || []}
                                    onChange={(value) => onChangeRestriction({ payment_method: value })}
                                />
                                <InlineError className='mt-2' message={errorForm?.restriction?.payment_method} />
                            </div>
                            <div className={'flex flex-col space-y-3'}>
                                <Checkbox
                                    name={'new_user_only'}
                                    checked={voucherDetail?.new_user_only}
                                    label={'Valid for New Customer'}
                                    onChange={(item) => onChangeRestriction({ [item?.name]: item?.checked })}
                                />
                                <InlineError className='mt-2' message={errorForm?.restriction?.new_user_only} />
                            </div>
                        </div>
                    </div>
                }
            />
        </div>
    )
}
